/**
 * Block client navigations until the first hydration finishes, so we do not
 * swap the SSR tree mid-mount.
 *
 * Nuxt itself calls router.replace({ force: true }) inside app:created — before
 * mount. Vue Router may stringify spaces as "+" while the browser URL still
 * has "%20", so to.fullPath !== from.fullPath. Waiting for onNuxtReady here
 * deadlocks: replace never finishes, the app never mounts, Recaptcha / forms
 * stay as dead SSR HTML. Allow that hydrating replace through.
 */
export default defineNuxtPlugin((nuxtApp) => {
    let ready = !nuxtApp.isHydrating

    if (!ready) {
        onNuxtReady(() => { ready = true })
    }

    const router = useRouter()

    router.beforeEach((to, from, next) => {
        if (ready || nuxtApp.isHydrating || to.fullPath === from.fullPath) {
            return next()
        }

        onNuxtReady(() => next())
    })
})
